<i18n lang='yml' src='../i18n/LoadingAnimation.yml'></i18n>

<template>
  <transition-group>
    <div key="above" class="la-above-spinner">
      <slot name="above"></slot>
    </div>
    <div key="spinner" class="la-spinner" :style="spinnerStyle"></div>
    <div key="below" class="la-below-spinner" :style="belowSpinnerStyle">
      <slot name="below">
        <div class="text-center">
          {{ $t('loading_text') }}
        </div>
      </slot>
    </div>
  </transition-group>
</template>

<script>
export default {
    props: {
      spinnerSize: { title: Number, default: 120 },
      spinnerLineWidth: { title: Number, default: 5 },
      spinnerLineColour: { title: String, default: 'rgb(238, 238, 238)' },
      spinnerHighlightLineColour: { title: String, default: 'rgb(33, 150, 243)' },
      spinnerSpeed: { title: Number, default: 0.8 },
      belowSpinnerMarginTop: { title: String, default: '10px' }
    },

    computed: {
      spinnerStyle() {
        return {
          'margin': '0 auto',
          'border-radius': '100%',
          'border': `${this.spinnerLineWidth}px solid ${this.spinnerLineColour}`,
          'border-top': `${this.spinnerLineWidth}px solid ${this.spinnerHighlightLineColour}`,
          'width': `${this.spinnerSize}px`,
          'height': `${this.spinnerSize}px`,
          'animation': `la-spinner-spin ${this.spinnerSpeed}s linear infinite`,
          'transition': `all 1s linear`
        };
      },

      belowSpinnerStyle() {
        return {
          'margin-top': `${this.belowSpinnerMarginTop}`
        };
      }
    }
  }

</script>

<style>
  @keyframes la-spinner-spin {
    0% { transform: rotate(0deg); }
    25% { transform: rotate(90deg); }
    50% { transform: rotate(180deg); }
    75% { transform: rotate(270deg); }
    100% { transform: rotate(360deg); }
  }
</style>
